module.exports = __webpack_public_path__ + "static/media/store-card.39bdc5a9.jpg";